<app-benefits-list
  [benefitsListItems]="benefitsListCoveredItems()"
  [iconTemplate]="iconTemplateCoveredItems"
  [title]="title()"
>
  <ng-template #iconTemplateCoveredItems let-icon="iconName">
    <div class="benefits-list-items-covered-items__icon-container">
      <app-icon
        [name]="icon"
        [size]="'sm'"
        class="benefits-list-items-covered-items__icon"
      />
    </div>
  </ng-template>
</app-benefits-list>
